var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportsIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 20,
  fill: "none",
  viewBox: "0 0 16 20",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FEFEFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.4,
  d: "M9.5 1.5H2.7A1.7 1.7 0 0 0 1 3.2v13.6a1.7 1.7 0 0 0 1.7 1.7h10.2a1.7 1.7 0 0 0 1.7-1.7V6.6M9.5 1.5l5.1 5.1M9.5 1.5v5.1h5.1m-3.4 4.25H4.4m6.8 3.4H4.4m1.7-6.8H4.4"
})));
export { SvgReportsIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/reports-icon.svg";